import { ReactNode, useEffect } from 'react';
import { X } from 'react-feather';
import styles from './Drawer.module.css';

interface DrawerProps {
  children?: ReactNode;
  onClose: () => void;
  title: ReactNode | string;
  theme?: 'gray' | 'white';
  full?: boolean;
  renderAction?: () => ReactNode;
}

export function Drawer({ children, onClose, theme, title, full, renderAction }: DrawerProps) {
  useEffect(() => {
    // document.body.style.overflow = 'hidden';
    // // save current position
    const scrollPosition = window.pageYOffset;

    document.body.style.position = 'fixed';
    document.body.style.top = `-${scrollPosition}px`;
    document.body.style.left = '0';
    document.body.style.right = '0';
    document.body.style.width = '100%';
    return () => {
      // document.body.style.overflow = 'auto';
      document.body.style.position = '';
      document.body.style.top = '';

      window.scrollTo(0, scrollPosition);
    };
  }, []);

  return (
    <div className={`${styles.drawerLayout} ${theme ? styles[theme] : ''}`}>
      <div className={`${styles.drawerBar} ${full ? styles.wfull : ''}`}>
        <div className={styles.drawerHeader}>
          <div className={styles.closeButton} onClick={onClose}>
            <X size={24} />
          </div>
          <span className={styles.drawerHeaderTitle}>{title}</span>
        </div>
        <div className={styles.drawerBody}>{children}</div>
        {renderAction && <div className={styles.drawerFooter}>{renderAction()}</div>}
      </div>
    </div>
  );
}
